<template>
  <div>
    <div
      v-if="hasRole('ROLE_SALES_MANAGER') || hasRole('ROLE_BUSINESS_ADMIN')"
      class="level is-mobile"
    >
      <div class="level-left" />
      <div class="level-right">
        <div class="level-item">
          <b-field class="is-light">
            <b-select
              v-model="bookingswitch"
              placeholder="FILTER BY"
              size="is-small"
            >
              <option value="bookingamount">
                Bookings
              </option>

              <option value="invoiceamount">
                Sales
              </option>
            </b-select>
          </b-field>
        </div>

        <div class="level-item">
          <b-field class="is-light">
            <b-select
              v-model="selected"
              placeholder="FILTER BY"
              size="is-small"
            >
              <option value="all">
                All
              </option>

              <hr class="dropdown-divider">

              <option value="self">
                Self
              </option>

              <hr class="dropdown-divider">

              <option
                v-for="(subordinate, subordinateIndex) in subordinatesList"
                :key="subordinateIndex"
                :value="subordinate.id"
              >
                {{ subordinate.fullname.trim() }}
              </option>
              <hr class="dropdown-divider">

              <option
                v-for="team in teams"
                :key="team.id"
                :value="`team${team.id}`"
              >
                {{ team.name }}
              </option>
            </b-select>
          </b-field>
        </div>
      </div>
    </div>

    <div class="card is-rounded-card is-spaced-top">
      <header class="card-header">
        <p class="card-header-title">
          ytd sales vs goals
        </p>
      </header>

      <div class="card-content">
        <highcharts
          v-if="hasData"
          :options="ytdSalesVsGoalsSeries"
        />

        <div
          v-else
          class="level is-mobile"
        >
          <div class="level-item has-text-centered">
            <div>
              <figure class="image">
                <img
                  src="@/assets/images/no-data.svg"
                  alt="No Data"
                >
              </figure>
              <b-button
                type="is-primary"
                size="is-small"
              >
                no data found
              </b-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { Chart } from 'highcharts-vue';

export default {
  name: 'YtdSalesVsGoals',

  components: {
    highcharts: Chart,
  },

  data: () => ({
    self: localStorage.getItem('user_id'),
    selected: '',
    bookingswitch: 'bookingamount',
  }),

  computed: {
    ...mapGetters({
      ytdSalesVsGoals: 'Graphs/getYtdSalesVsGoals',
      subordinatesList: 'Users/getSubordinates',
      teams: 'Graphs/getTeams',
    }),

    hasData() {
      const data = { ...this.ytdSalesVsGoals };
      const goals = Object.values(data).map((el) => el.goalsamount).reduce((a, b) => a + b, 0);
      return goals > 0;
    },

    ytdSalesVsGoalsSeries() {
      const data = { ...this.ytdSalesVsGoals };

      const categories = Object.keys(data);

      const series = Object.values(data).map((el) => el[this.bookingswitch]);
      const goals = Object.values(data).map((el) => el.goalsamount);

      const openDrilldown = (type) => {
        this.$emit('open-drilldown', {
          name: 'opportunities',
          filters: { type: `${type}` },
        });
      };

      return {
        chart: {
          type: 'bar',
          style: {
            fontFamily: 'Open Sans',
          },
        },

        credits: {
          enabled: false,
        },

        title: {
          text: null,
        },

        tooltip: {
          pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b> ({point.percentage:.0f}%)<br/>',
          shared: true,
        },

        plotOptions: {
          series: {
            stacking: 'percent',
            allowPointSelect: true,
            point: {
              events: {
                select(event) {
                  openDrilldown(event.target.category);
                },
              },
            },
          },
        },

        colors: ['#CCCCCC', '#3B90D3'],

        xAxis: {
          categories,
          allowDecimals: false,
        },

        yAxis: {
          allowDecimals: false,
        },

        series: [
          {
            name: this.bookingswitch === 'bookingamount' ? 'Sold' : 'Invoiced',
            data: series,
          }, {
            name: 'Goals',
            data: goals,
          },
        ],

        exporting: {
          buttons: {
            contextButton: {
              menuItems: [
                'printChart',
                'separator',
                'downloadPNG',
                'downloadJPEG',
                'downloadPDF',
                'downloadSVG',
              ],
            },
          },
        },
      };
    },
  },

  watch: {
    selected: {
      handler(value) {
        if (value === 'all') {
          this.$store.dispatch('Graphs/fetchYtdSalesVsGoals', { teamid: '', userid: '' });
        } else if (value === 'self') {
          this.$store.dispatch('Graphs/fetchYtdSalesVsGoals', { teamid: '', userid: this.self });
        } else if (value.toString().startsWith('team')) {
          this.$store.dispatch('Graphs/fetchYtdSalesVsGoals', { teamid: value.toString().substring(4), userid: '' });
        } else {
          this.$store.dispatch('Graphs/fetchYtdSalesVsGoals', { teamid: '', userid: value });
        }
      },

      deep: true,
    },
  },

  async created() {
    try {
      if (this.hasRole('ROLE_SALES_PERSON')) {
        await this.$store.dispatch('Graphs/fetchYtdSalesVsGoals', { teamid: '', userid: this.self });
      } else {
        await this.$store.dispatch('Graphs/fetchYtdSalesVsGoals', { teamid: '', userid: '' });
      }
      this.selected = this.hasRole('ROLE_SALES_PERSON') ? 'self' : 'all';
    } catch (error) {
      console.error(error);
    }
  },

};
</script>

<style>

</style>
